import { ASSETS } from "./content";

export const insights = {
  it: {
    navLabel: "Approfondimenti",
    overline: "Approfondimenti",
    title: "Norme, sicurezza e innovazione: quello che conta sapere.",
    sub: "Analisi e aggiornamenti dal nostro team tecnico: normativa macchine, sicurezza, documentazione e trasformazione digitale.",
    readMore: "Leggi l'approfondimento",
    allCta: "Tutti gli approfondimenti",
    homeOverline: "Dal nostro osservatorio",
    homeTitle: "Approfondimenti e novità normative",
    items: [
      {
        tag: "Cybersecurity",
        date: "10/2026",
        title: "Cybersecurity delle macchine: cosa cambia con il Regolamento (UE) 2023/1230",
        excerpt:
          "Dal 20 gennaio 2027 la sicurezza informatica diventa requisito di legge per le macchine: protezione dalla corruzione, software aggiornabile, IEC 62443. La sintesi operativa dai whitepaper di Bosch Rexroth, Phoenix Contact, Pilz e Siemens.",
        image: ASSETS.cyber,
        to: "/approfondimenti/cybersecurity-macchine",
      },
      {
        tag: "Documentazione",
        date: "10/2026",
        title: "Il manuale d'uso: istruzioni che proteggono (e fanno vendere)",
        excerpt:
          "Cosa deve contenere il manuale secondo la normativa, perché la lingua conta e gli errori più comuni — dai contenuti del libro Aldebran sulla Direttiva Macchine.",
        image: "/articles/manuale-uso.png",
        to: "/approfondimenti/manuale-uso",
      },
      {
        tag: "Sicurezza",
        date: "10/2026",
        title: "Il fascicolo tecnico: la memoria della macchina",
        excerpt:
          "Disegni, calcoli, prove e valutazione dei rischi: cosa deve contenere davvero il fascicolo tecnico e perché non va consegnato al cliente.",
        image: "/articles/fascicolo-tecnico.png",
        to: "/approfondimenti/fascicolo-tecnico",
      },
      {
        tag: "Conformità",
        date: "10/2026",
        title: "Marcatura CE delle macchine: regole, percorso e responsabilità",
        excerpt:
          "Visibile, leggibile, indelebile — ma soprattutto l'ultimo passo di un percorso documentato. Le regole formali e ciò che cambia con il Regolamento 2023/1230.",
        image: "/articles/marcatura-ce.png",
        to: "/approfondimenti/marcatura-ce",
      },
      {
        tag: "Sicurezza",
        date: "10/2026",
        title: "La valutazione dei rischi: il cuore della conformità della macchina",
        excerpt:
          "Il processo iterativo della EN ISO 12100 spiegato passo per passo: limiti della macchina, pericoli, stima, riduzione del rischio e documentazione che difende il fabbricante.",
        image: "/articles/valutazione-rischi.png",
        to: "/approfondimenti/valutazione-rischi",
      },
      {
        tag: "Sicurezza",
        date: "10/2026",
        title: "Sicurezza funzionale: PL e SIL spiegati ai costruttori",
        excerpt:
          "EN ISO 13849-1 e IEC 62061 senza misteri: Performance Level, SIL, MTTFd, copertura diagnostica e gli errori di calcolo più comuni.",
        image: "/articles/sicurezza-funzionale.png",
        to: "/approfondimenti/sicurezza-funzionale",
      },
      {
        tag: "Sicurezza",
        date: "10/2026",
        title: "Ripari, interblocchi e arresto di emergenza: la protezione fisica della macchina",
        excerpt:
          "Ripari fissi e mobili, interblocchi con blocco del riparo, categorie di arresto e distanze di sicurezza delle barriere: le regole e gli errori da evitare.",
        image: "/articles/ripari-e-interblocchi.png",
        to: "/approfondimenti/ripari-e-interblocchi",
      },
      {
        tag: "Direttive",
        date: "10/2026",
        title: "Direttiva ATEX: macchine e impianti in atmosfere esplosive",
        excerpt:
          "Zone, categorie, marchio Ex e sorgenti di innesco: cosa deve fare il costruttore quando la macchina opera dove l'atmosfera può esplodere.",
        image: "/articles/atex.png",
        to: "/approfondimenti/atex",
      },
      {
        tag: "Sicurezza",
        date: "10/2026",
        title: "Il rumore delle macchine: misura, dichiarazione e riduzione",
        excerpt:
          "Il rumore è un requisito di conformità: quali valori dichiarare, come misurarli davvero e perché la strada giusta è la progettazione a bassa rumorosità.",
        image: "/articles/rumore.png",
        to: "/approfondimenti/rumore",
      },
      {
        tag: "Direttive",
        date: "10/2026",
        title: "La Direttiva PED applicata alle macchine: attrezzature a pressione senza sorprese",
        excerpt:
          "Serbatoi, tubazioni, scambiatori: quando una parte della macchina rientra nella PED 2014/68/UE, come si classifica e chi deve intervenire.",
        image: "/articles/ped.png",
        to: "/approfondimenti/ped",
      },
      {
        tag: "Sicurezza",
        date: "10/2026",
        title: "Sicurezza delle presse: dove l'esperienza conta di più",
        excerpt:
          "EN 692 ed EN 693, comandi bimanuali, barriere di tipo 4 e retrofit: la sicurezza delle presse si gioca su scelte che non ammettono approssimazione.",
        image: "/articles/presse.png",
        to: "/approfondimenti/presse",
      },
      {
        tag: "Direttive",
        date: "10/2026",
        title: "Compatibilità elettromagnetica (EMC): macchine immuni e rispettose",
        excerpt:
          "Emissioni e immunità secondo la 2014/30/UE: norme per l'industria, prove da documentare e il legame diretto con la sicurezza funzionale.",
        image: "/articles/emc.png",
        to: "/approfondimenti/emc",
      },
      {
        tag: "Direttive",
        date: "10/2026",
        title: "Dispositivi medici e macchine: quando le normative si incontrano",
        excerpt:
          "Sterilizzatrici e diagnostica sono spesso macchine e dispositivi medici insieme: MDR 2017/745, ISO 14971 e il doppio percorso di conformità.",
        image: "/articles/dispositivi-medici.png",
        to: "/approfondimenti/dispositivi-medici",
      },
      {
        tag: "Settori",
        date: "10/2026",
        title: "Sicurezza delle macchine nel settore farmaceutico",
        excerpt:
          "GMP e normativa macchine nello stesso progetto: progettazione igienica, contenimento, validazione e gli errori che si pagano cari.",
        image: "/articles/farma.png",
        to: "/approfondimenti/farma",
      },
      {
        tag: "Normativa",
        date: "2026",
        title: "Regolamento Macchine (UE) 2023/1230: la roadmap verso il 20 gennaio 2027",
        excerpt:
          "Cosa cambia rispetto alla Direttiva 2006/42/CE e come organizzare la transizione senza rischiare l'accesso al mercato UE.",
        image: ASSETS.blueprint,
        to: "/regolamento-ue",
      },
      {
        tag: "Digital",
        date: "2026",
        title: "Digital Twin e manutenzione predittiva: la fabbrica 5.0 è già qui",
        excerpt:
          "Sensori, dati e simulazione: come la transizione 5.0 riduce i fermi macchina e i costi di non qualità.",
        image: ASSETS.factory,
        to: "/industria-4-5",
      },
    ],
  },
  en: {
    navLabel: "Insights",
    overline: "Insights",
    title: "Regulations, safety and innovation: what really matters.",
    sub: "Analysis and updates from our technical team: machinery regulation, safety, documentation and digital transformation.",
    readMore: "Read the insight",
    allCta: "All insights",
    homeOverline: "From our observatory",
    homeTitle: "Insights and regulatory updates",
    items: [
      {
        tag: "Cybersecurity",
        date: "10/2026",
        title: "Machinery cybersecurity: what changes with Regulation (EU) 2023/1230",
        excerpt:
          "From 20 January 2027 cybersecurity becomes a legal requirement for machinery: protection against corruption, updateable software, IEC 62443. An operational summary from the whitepapers of Bosch Rexroth, Phoenix Contact, Pilz and Siemens.",
        image: ASSETS.cyber,
        to: "/approfondimenti/cybersecurity-macchine",
      },
      {
        tag: "Documentation",
        date: "10/2026",
        title: "The user manual: instructions that protect (and help sell)",
        excerpt:
          "What the manual must contain under the legislation, why language matters and the most common mistakes — from the contents of Aldebran's book on the Machinery Directive.",
        image: "/articles/manuale-uso.png",
        to: "/approfondimenti/manuale-uso",
      },
      {
        tag: "Safety",
        date: "10/2026",
        title: "The technical file: the machine's memory",
        excerpt:
          "Drawings, calculations, tests and risk assessment: what the technical file must really contain and why it should not be handed over to the customer.",
        image: "/articles/fascicolo-tecnico.png",
        to: "/approfondimenti/fascicolo-tecnico",
      },
      {
        tag: "Compliance",
        date: "10/2026",
        title: "CE marking of machinery: rules, process and responsibilities",
        excerpt:
          "Visible, legible, indelible — but above all the last step of a documented process. The formal rules and what changes with Regulation 2023/1230.",
        image: "/articles/marcatura-ce.png",
        to: "/approfondimenti/marcatura-ce",
      },
      {
        tag: "Safety",
        date: "10/2026",
        title: "Risk assessment: the heart of machine compliance",
        excerpt:
          "The iterative EN ISO 12100 process explained step by step: machine limits, hazards, estimation, risk reduction and the documentation that protects the manufacturer.",
        image: "/articles/valutazione-rischi.png",
        to: "/approfondimenti/valutazione-rischi",
      },
      {
        tag: "Safety",
        date: "10/2026",
        title: "Functional safety: PL and SIL explained to manufacturers",
        excerpt:
          "EN ISO 13849-1 and IEC 62061 without mysteries: Performance Levels, SIL, MTTFd, diagnostic coverage and the most common calculation mistakes.",
        image: "/articles/sicurezza-funzionale.png",
        to: "/approfondimenti/sicurezza-funzionale",
      },
      {
        tag: "Safety",
        date: "10/2026",
        title: "Guards, interlocks and emergency stop: the machine's physical protection",
        excerpt:
          "Fixed and movable guards, interlocks with guard locking, stop categories and light curtain safety distances: the rules and the mistakes to avoid.",
        image: "/articles/ripari-e-interblocchi.png",
        to: "/approfondimenti/ripari-e-interblocchi",
      },
      {
        tag: "Directives",
        date: "10/2026",
        title: "ATEX Directive: machines and plants in explosive atmospheres",
        excerpt:
          "Zones, categories, the Ex mark and ignition sources: what the manufacturer must do when the machine operates where the atmosphere can explode.",
        image: "/articles/atex.png",
        to: "/approfondimenti/atex",
      },
      {
        tag: "Safety",
        date: "10/2026",
        title: "Machinery noise: measurement, declaration and reduction",
        excerpt:
          "Noise is a conformity requirement: which values to declare, how to really measure them and why the right path is low-noise design.",
        image: "/articles/rumore.png",
        to: "/approfondimenti/rumore",
      },
      {
        tag: "Directives",
        date: "10/2026",
        title: "The PED Directive applied to machines: pressure equipment without surprises",
        excerpt:
          "Vessels, piping, heat exchangers: when part of the machine falls under the PED 2014/68/EU, how it is classified and who must intervene.",
        image: "/articles/ped.png",
        to: "/approfondimenti/ped",
      },
      {
        tag: "Safety",
        date: "10/2026",
        title: "Press safety: where experience matters most",
        excerpt:
          "EN 692 and EN 693, two-hand controls, type 4 light curtains and retrofits: press safety rests on choices that tolerate no approximation.",
        image: "/articles/presse.png",
        to: "/approfondimenti/presse",
      },
      {
        tag: "Directives",
        date: "10/2026",
        title: "Electromagnetic compatibility (EMC): immune and respectful machines",
        excerpt:
          "Emissions and immunity under 2014/30/EU: standards for industry, tests to document and the direct link with functional safety.",
        image: "/articles/emc.png",
        to: "/approfondimenti/emc",
      },
      {
        tag: "Directives",
        date: "10/2026",
        title: "Medical devices and machines: when regulations meet",
        excerpt:
          "Sterilizers and diagnostics are often machines and medical devices at once: MDR 2017/745, ISO 14971 and the dual compliance route.",
        image: "/articles/dispositivi-medici.png",
        to: "/approfondimenti/dispositivi-medici",
      },
      {
        tag: "Sectors",
        date: "10/2026",
        title: "Machinery safety in the pharmaceutical sector",
        excerpt:
          "GMP and machinery legislation in the same project: hygienic design, containment, validation and the mistakes that cost dearly.",
        image: "/articles/farma.png",
        to: "/approfondimenti/farma",
      },
      {
        tag: "Regulation",
        date: "2026",
        title: "Machinery Regulation (EU) 2023/1230: the roadmap to 20 January 2027",
        excerpt:
          "What changes compared to Directive 2006/42/EC and how to organise the transition without risking access to the EU market.",
        image: ASSETS.blueprint,
        to: "/regolamento-ue",
      },
      {
        tag: "Digital",
        date: "2026",
        title: "Digital Twin and predictive maintenance: the 5.0 factory is already here",
        excerpt:
          "Sensors, data and simulation: how the 5.0 transition reduces machine downtime and non-quality costs.",
        image: ASSETS.factory,
        to: "/industria-4-5",
      },
    ],
  },
};
